<template>
  <div>
    <Header
      :title="$t('presets.presetCreate').toString()"
      :show-back-button="true"
      :items="headerButtons"
      @back="$router.push({ name: 'projectSettingsPresets' })"
      @save="storePreset"
    />
    <div class="card card-custom">
      <div class="card-body">
        <FormHelper
          ref="form"
          v-model="preset"
          :form="form"
          :preset="formPreset"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FormHelper from "@/components/Tools/FormHelper/FormHelper.vue";
import Header from "@/components/Tools/Header/Header.vue";
import {
  addEventToLoadingQueue,
  removeEventFromLoadingQueue
} from "@/composables/useLoadingQueue";
import Presets from "@/components/Settings/Presets/presets";
import { mapGetters } from "vuex";

export default {
  name: "ProjectsSettingsPresetCreate",
  components: { Header, FormHelper },
  data() {
    return {
      headerButtons: [
        {
          type: "button",
          title: this.$t("general.save"),
          emit: "save"
        }
      ],
      formPreset: {
        snippetPrefix: "preset",
        enableVariables: false
      },
      form: [
        {
          label: this.$t("presets.name"),
          name: "name",
          type: "text",
          disableReturnType: true,
          default: "",
          validations: {
            required: true,
            minLength: 3
          }
        },
        {
          label: this.$t("presets.label"),
          name: "label",
          type: "text",
          disableReturnType: true,
          default: "",
          validations: {
            required: true,
            minLength: 3
          }
        },
        {
          label: this.$t("presets.type"),
          name: "type",
          type: "select",
          options: [
            {
              text: "json",
              value: "json"
            },
            {
              text: "text",
              value: "text"
            },
            {
              text: "number",
              value: "number"
            }
          ]
        },
        {
          label: this.$t("presets.value"),
          name: "value",
          type: "json",
          returnJson: true,
          fields: [
            {
              name: "key"
            },
            {
              name: "value"
            }
          ],
          dependsOn: [
            {
              name: "type",
              values: ["json"]
            }
          ]
        },
        {
          label: this.$t("presets.value"),
          name: "value",
          type: "text",
          dependsOn: [
            {
              name: "type",
              values: ["text"]
            }
          ]
        },
        {
          label: this.$t("presets.value"),
          name: "value",
          type: "number",
          dependsOn: [
            {
              name: "type",
              values: ["number"]
            }
          ]
        }
      ],
      preset: {
        name: "",
        label: "",
        type: "json",
        value: "",
        namespace: ""
      }
    };
  },
  computed: {
    ...mapGetters(["selectedProject"])
  },
  watch: {
    "preset.type": {
      handler: function () {
        this.preset.value = null;
      }
    }
  },
  methods: {
    storePreset() {
      addEventToLoadingQueue({ key: "storePreset" });

      // Set additional preset values
      let preset = this.preset;
      preset.project_id = this.selectedProject.id;
      preset.namespace = preset.label;

      Presets.store(preset)
        .then(() => {
          removeEventFromLoadingQueue({
            key: "storePreset",
            type: "success",
            prefix: "presets",
            name: "presetCreated"
          });

          this.$router.push({ name: "projectSettingsPresets" });
        })
        .catch(error => {
          this.$error(error);
        });
    }
  }
};
</script>
